import { gettext } from '@eventbrite/i18n';

export const REFUND_GENERIC_INVALID_ORDER_MESSAGE = gettext(
    "We don't recognize that Order ID. Check your confirmation email for the correct details. ",
);
export const REFUND_REQUEST_SUCCESS_MESSAGE = gettext(
    'Success! Your refund request was submitted',
);
export const REFUND_REQUEST_ALREADY_EXISTS_MESSAGE = gettext(
    'Order ID already has a refund request in process. Please allow up to 8 weeks for a reply',
);
export const REFUND_REQUEST_NOT_VALID_MESSAGE = gettext(
    'Enter a valid email address and Order ID',
);
export const REFUND_REQUEST_ORDER_IS_FREE_MESSAGE = gettext(
    'This order is a free order. To submit a paid order for a refund please check your confirmation email. ',
);
export const REFUND_REQUEST_ORDER_IS_NOT_EPP_MESSAGE = gettext(
    "This order was not processed by Eventbrite therefore we cannot issue a refund on that processor's behalf. Please contact the organizer directly to request a refund. ",
);
export const REFUND_ORDER_EMAIL_DOES_NOT_MATCH_MESSAGE = gettext(
    'Email and Order ID do not match. Check your confirmation email. ',
);
export const REFUND_REQUEST_ORDER_ALREADY_REFUNDED_MESSAGE = gettext(
    'This order has already been refunded. Please allow up to 7 business days to show up in your account. ',
);
export const REFUND_REQUEST_ORDER_TRANSFERRED_MESSAGE = gettext(
    'This order has been transferred to another event. Check your confirmation email for your new Order ID. ',
);
export const REFUND_REQUEST_CAPTCHA_ERROR_MESSAGE = gettext(
    'There was an error with your captcha code. Please, try again. ',
);
export const REFUND_REQUEST_CREDIT_CARD_DETECTED_MESSAGE = gettext(
    'Please remove your credit card details to continue. ',
);
export const REFUND_REQUEST_ORDER_ALREADY_VOIDED_MESSAGE = gettext(
    'This order has been already voided via chargeback through your bank. ',
);
